import {
  type INotifiable,
  type NotifySettings,
  type ShouldNotifyWithProgress,
  ShouldNotifyWithProgressIds,
} from "./types";
import { CommunicationChannels } from "../../enums";

export const getNotifyTypesWithProgress = (config: ShouldNotifyWithProgress) => {
  const shouldNotifySet = [
    { id: ShouldNotifyWithProgressIds.ShouldNotifyNotStarted, shouldNotify: config.shouldNotifyNotStarted },
    { id: ShouldNotifyWithProgressIds.ShouldNotifyInProgress, shouldNotify: config.shouldNotifyInProgress },
    { id: ShouldNotifyWithProgressIds.ShouldNotifyCompleted, shouldNotify: config.shouldNotifyCompleted },
  ];
  const activeShouldNotifySet = shouldNotifySet.filter(({ shouldNotify }) => shouldNotify);

  return shouldNotifySet.length === activeShouldNotifySet.length
    ? [ShouldNotifyWithProgressIds.All]
    : activeShouldNotifySet.map(({ id }) => id);
};

export const initialNotifyConfigWithProgress: INotifiable<ShouldNotifyWithProgress> = {
  shouldNotifyNotStarted: false,
  shouldNotifyInProgress: false,
  shouldNotifyCompleted: false,
  getShouldNotify: (config) =>
    config.shouldNotifyNotStarted || config.shouldNotifyInProgress || config.shouldNotifyCompleted,
  communicationChannel: CommunicationChannels.Email,
  getCommunicationChannel: (config) => config.communicationChannel,
  notifyTypes: (config) => getNotifyTypesWithProgress(config),
};

export const initialNotifyConfigDefault: INotifiable<NotifySettings> = {
  shouldNotifyUsers: false,
  communicationChannel: CommunicationChannels.Email,
  getCommunicationChannel: (config) => config.communicationChannel,
  getShouldNotify: (config) => config.shouldNotifyUsers,
};
